import { config } from "../lib/config";

export function Logo() {
  return (
    <span className="flex items-center gap-3">
      {config.logoPath ? (
        <img
          src={config.logoPath}
          alt="شعار شركة كيان الاستشارات الهندسية"
          className="h-11 w-12 shrink-0 rounded-sm bg-white object-contain"
          onError={(event) => {
            event.currentTarget.style.display = "none";
          }}
        />
      ) : (
        <span className="grid h-11 w-11 place-items-center rounded-md bg-charcoal text-lg font-bold text-gold">
          ك
        </span>
      )}
      <span className="leading-tight">
        <strong className="block text-sm font-bold text-current">
          {config.companyLegalNameAr}
        </strong>
        <span className="block text-xs font-semibold opacity-75">
          {config.valuationUnitNameAr}
        </span>
      </span>
    </span>
  );
}
